import Api from "./Api";
import Csrf from "./Csrf";

export default {

		/**
	  * Get All Victims
	  */
	  getAll(){
      return [this.getStandards(), this.getPrivates()];
	  },

	  /**
	  * Get Standard Victims
	  */
    async getStandards(){
      //await Csrf.getCookie();
      return Api.get("/victims");
    },

    /**
	  * Get Private Victims
	  */
    async getPrivates(){
      //await Csrf.getCookie();
      return Api.get("/pvictims");
    },

    /**
	  * Delete Standard Victims
	  */
    async deleteStandards(ids) {
      //await Csrf.getCookie();
      return Api.delete("/victims/"+ids);
    },

    /**
	  * Delete Private Victims
	  */
    async deletePrivates(ids) {
      //await Csrf.getCookie();
      return Api.delete("/pvictims/"+ids);
    },

};